module.exports = __webpack_public_path__ + "img/flex_discount.f4338ee.webp";